module.exports = "/_next/static/images/bullet-9a45ac54343a374d849d99bae86df07a.svg";